import styled from 'styled-components'
import bg_login from '../assets/bg_login.jpg'
import { defaultTheme } from '../styles/themes/defaultTheme'
import { Outlet } from 'react-router-dom'
import { LanguageSelector } from '../components/LanguageSelector'

export const LoginLayout = () => {
    return (
        <StyleContainer className="redesign">
            <main>
                <div className="main-container">
                    <Outlet />
                </div>
            </main>
            <footer>
                <LanguageSelector />
            </footer>
        </StyleContainer>
    )
}

const StyleContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    place-self: center;
    background: url('${bg_login}');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    height: 100dvh;
    width: 100dvw;
    .center {
        text-align: center;
    }

    > main {
        width: 330px;
        margin: auto;
        @media screen and (max-width: 768px) {
            max-width: 330px;
        }
        .main-container {
            background-color: ${defaultTheme.color.white};
            padding: 20px;
            border-radius: 20px;

            h1.title {
                font-size: 18px;
                text-align: center;
                margin-bottom: 1em;
            }

            button {
                box-sizing: border-box;
                width: 100%;
                min-height: 55px;
            }
        }
    }

    footer {
        width: 100%;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: flex-end;

        & label,
        & label select {
            border: 0;
            border-radius: 0;
            background-color: transparent;
            text-align: center;
            opacity: 0.9;
        }

        & label select,
        & label select:focus-within {
            appearance: auto;
            background-image: none;
            border: 0;
            box-shadow: none;
        }
    }
`
